import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(private auth: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const params = new URLSearchParams(window.location.search);

    const isAuthCallback = params.has('code') && params.has('state');
    const isPostLogout = params.get('postLogout') === 'true';
    const isReauth = params.get('reauth') === '1';

    if (isAuthCallback || isPostLogout || isReauth) {
      return of(false);
    }

    return this.auth.isAuthenticated$.pipe(
      take(1),
      map(loggedIn => {
        if (!loggedIn) {
          this.auth.login(state.url);
          return false;
        }

        return true;
      })
    );
  }
}
